import { api } from "../api";
import { IProfile, ISingIn } from "../interfaces/usuarios";

export class UserService {

  async getProfile(token?: string): Promise<IProfile> {
    return api
      .get<IProfile>('/auth/profile', {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => response.data)
      .catch((error) => {
        throw error;
      });
  }
  

  async signIn(payload: ISingIn): Promise<ISingIn> {
    return api.post<ISingIn>('/auth/login', payload)
      .then((response) => response.data)
      .catch((error) => {
        throw error;
      });
  }

  async signUp(payload: any): Promise<ISingIn> {
    return api.post<ISingIn>('/usuarios', payload)
      .then((response) => response.data)
      .catch((error) => {
        throw error;
      });
  }

  async createSuperUser(payload: any): Promise<ISingIn> {
    return api.post<ISingIn>('/usuarios', payload)
      .then((response) => response.data)
      .catch((error) => {
        throw error;
      });
  }
}
